const partRequestMenu = {
  label: 'pages.partRequest.menu',
  icon: 'mdi-chat-question',
  children: [],
  highlight: false,
  notificationCount: null
}
const remoteSupportMenu = {
  label: 'pages.remoteSupport.menu',
  icon: 'mdi-face-agent',
  children: [],
  highlight: false,
  notificationCount: null
}
const repairMenu = {
  label: 'pages.repair.partsAndHanheldsRepair',
  icon: 'mdi-list-box',
  children: [],
  highlight: false,
  notificationCount: null
}
// const reportMenu = {
//   label: 'pages.repair.reports',
//   icon: 'mdi-chart-pie',
//   children: [
//     {
//       label: 'pages.repair.generalReport',
//       icon: "file-chart",
//       link: 'reports/general',
//     }
//   ],
//   highlight: false
// }
const usersManagementMenu = {
  label: 'pages.contact.users',
  icon: 'mdi-account-group',
  children: [
    {
      label: 'pages.contact.userList',
      icon: "account-multiple-outline",
      link: 'contacts',
    }, {
      label: 'pages.contact.newContact',
      icon: "account-plus-outline",
      link: 'create/contact',
    }
  ],
  highlight: false
}
const settingsMenu = {
  label: 'pages.mail.settings',
  icon: 'mdi-cog',
  children: [
    {
      label: 'pages.mail.mailNotification',
      icon: "tune-variant",
      link: 'mail-notification',
    }, {
      label: 'pages.part.parts',
      icon: "toy-brick-search-outline",
      link: 'parts',
    }, {
      label: 'pages.part.newPart',
      icon: "toy-brick-plus-outline",
      link: 'create/part',
    }
  ],
  highlight: false
}
const profileMenu = {
  label: 'pages.contact.profile',
  icon: 'mdi-account-circle',
  children: [
    {
      label: 'pages.contact.userDetails',
      icon: "card-account-details",
      link: 'profile',
    }, {
      label: 'pages.contact.logout',
      icon: "logout",
      // NOTE: set logout function
      action: null,
    }
  ],
  highlight: false
}

import { 
  //NOTE: [ADMIN, SUPER_ADMIN, SUPERVISOR, SERVICE, CLIENT, SUSTAINABILITY_MANAGER]
  partRequestList,
  //NOTE: [ADMIN, SUPER_ADMIN, SUPERVISOR, SERVICE, CLIENT, SUSTAINABILITY_MANAGER]
  remoteSupportList,
  //NOTE: [SUPERVISOR, SERVICE, CLIENT]
  actionRequired,
  //NOTE: [ADMIN, SUPER_ADMIN, SUPERVISOR, SERVICE, CLIENT, SUSTAINABILITY_MANAGER]
  activeRepairs,
  //NOTE: [ADMIN, SUPER_ADMIN, SUPERVISOR, SERVICE, CLIENT, SUSTAINABILITY_MANAGER]
  closedRepair,
  //NOTE: [CLIENT]
  newPartRequest,
  //NOTE: [CLIENT]
  newRemoteSupport,
  //NOTE: [CLIENT]
  newRepair,
  //NOTE: [ADMIN, SUPER_ADMIN, SUPERVISOR, SUSTAINABILITY_MANAGER]
  generalReport
} from "@/data/navigator/btns"
import { copyObj } from "@/utils/StringUtil"
export function buildForAdmin() {
  const menus = {}
  //NOTE: Menu 1
  const partRequestMenuCopied = copyObj(partRequestMenu)
  partRequestMenuCopied.children.push(partRequestList)
  menus["partRequestMenu"] = partRequestMenuCopied

  //NOTE: Menu 2
  const remoteSupportMenuCopied = copyObj(remoteSupportMenu)
  remoteSupportMenuCopied.children.push(remoteSupportList)
  menus["remoteSupportMenu"] = remoteSupportMenuCopied

  //NOTE: Menu 3
  const repairMenuCopied = copyObj(repairMenu)
  repairMenuCopied.children.push(activeRepairs)
  repairMenuCopied.children.push(closedRepair)
  repairMenuCopied.children.push(generalReport)
  menus["repairMenu"] = repairMenuCopied

  //NOTE: Menu 4
  // menus["reportMenu"] = reportMenu

  //NOTE: Menu 5
  menus["usersManagementMenu"] = usersManagementMenu

  //NOTE: Menu 6
  menus["settingsMenu"] = settingsMenu

  //NOTE: Menu 7
  menus["profileMenu"] = profileMenu

  return menus
}

export function buildForSupervisor() {
  const menus = {}
  
  //NOTE: Menu 1
  const partRequestMenuCopied = copyObj(partRequestMenu)
  partRequestMenuCopied.children.push(partRequestList)
  menus["partRequestMenu"] = partRequestMenuCopied

  //NOTE: Menu 2
  const remoteSupportMenuCopied = copyObj(remoteSupportMenu)
  remoteSupportMenuCopied.children.push(remoteSupportList)
  menus["remoteSupportMenu"] = remoteSupportMenuCopied

  //NOTE: Menu 3
  const repairMenuCopied = copyObj(repairMenu)
  repairMenuCopied.children.push(actionRequired)
  repairMenuCopied.children.push(activeRepairs)
  repairMenuCopied.children.push(closedRepair)
  repairMenuCopied.children.push(generalReport)
  menus["repairMenu"] = repairMenuCopied

  //NOTE: Menu 4
  // menus["reportMenu"] = reportMenu

  //NOTE: Menu 5
  menus["profileMenu"] = profileMenu

  return menus
}

export function buildForService() {
  const menus = {}
  
  //NOTE: Menu 1
  const partRequestMenuCopied = copyObj(partRequestMenu)
  partRequestMenuCopied.children.push(partRequestList)
  menus["partRequestMenu"] = partRequestMenuCopied

  //NOTE: Menu 2
  const remoteSupportMenuCopied = copyObj(remoteSupportMenu)
  remoteSupportMenuCopied.children.push(remoteSupportList)
  menus["remoteSupportMenu"] = remoteSupportMenuCopied

  //NOTE: Menu 3
  const repairMenuCopied = copyObj(repairMenu)
  repairMenuCopied.children.push(actionRequired)
  repairMenuCopied.children.push(activeRepairs)
  repairMenuCopied.children.push(closedRepair)
  menus["repairMenu"] = repairMenuCopied

  //NOTE: Menu 4
  menus["profileMenu"] = profileMenu

  return menus
}

export function buildForClient() {
  const menus = {}
  
  //NOTE: Menu 1
  const partRequestMenuCopied = copyObj(partRequestMenu)
  partRequestMenuCopied.children.push(newPartRequest)
  partRequestMenuCopied.children.push(partRequestList)
  menus["partRequestMenu"] = partRequestMenuCopied

  //NOTE: Menu 2
  const remoteSupportMenuCopied = copyObj(remoteSupportMenu)
  remoteSupportMenuCopied.children.push(newRemoteSupport)
  remoteSupportMenuCopied.children.push(remoteSupportList)
  menus["remoteSupportMenu"] = remoteSupportMenuCopied

  //NOTE: Menu 3
  const repairMenuCopied = copyObj(repairMenu)
  repairMenuCopied.children.push(newRepair)
  repairMenuCopied.children.push(actionRequired)
  repairMenuCopied.children.push(activeRepairs)
  repairMenuCopied.children.push(closedRepair)
  menus["repairMenu"] = repairMenuCopied

  //NOTE: Menu 4
  menus["profileMenu"] = profileMenu

  return menus
}

export function buildForSM() {
  const menus = {}
  
  //NOTE: Menu 1
  const partRequestMenuCopied = copyObj(partRequestMenu)
  partRequestMenuCopied.children.push(partRequestList)
  menus["partRequestMenu"] = partRequestMenuCopied

  //NOTE: Menu 2
  const remoteSupportMenuCopied = copyObj(remoteSupportMenu)
  remoteSupportMenuCopied.children.push(remoteSupportList)
  menus["remoteSupportMenu"] = remoteSupportMenuCopied

  //NOTE: Menu 3
  const repairMenuCopied = copyObj(repairMenu)
  repairMenuCopied.children.push(activeRepairs)
  repairMenuCopied.children.push(closedRepair)
  menus["repairMenu"] = repairMenuCopied
  repairMenuCopied.children.push(generalReport)

  //NOTE: Menu 4
  // menus["reportMenu"] = reportMenu

  //NOTE: Menu 5
  menus["profileMenu"] = profileMenu

  return menus
}

//NOTE: /btns/ can be menus too here.
export function findTheHighlightPage(btns, $route) {
  btns.forEach(bm => {
    const isMenu = bm.children !== null && bm.children !== undefined
    if (isMenu) {
      bm.highlight = false
      bm.children.forEach(c => c.highlight = false)
    }
    else bm.highlight = false
  })

  for (const bm of btns) {
    const isMenu = bm.children !== null && bm.children !== undefined
    if (isMenu) {
      for (const c of bm.children) {
        if (processHighlight(c, $route)) {
          bm.highlight = true
          return {
            menu: bm,
            item: c
          }
        }
      }
    }
    else {
      if (processHighlight(bm, $route)) return bm
    }
  }

  return null
}
function processHighlight(b, $route) {
  const PATH = $route.path
  if (PATH.includes(b.link)) {
    b.highlight = true
    return true
  }

  return false
}